import script from './component-lib.esm5.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isEmbedLink ? _c('BtnExpand', {
    ref: "expand",
    attrs: {
      "isOpen": _vm.isOpen
    },
    on: {
      "close": function ($event) {
        _vm.isOpen = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        return [_c('ProfileBtn', _vm._b({
          staticClass: "v-profile-btn",
          attrs: {
            "component": "button",
            "url": _vm.linkUrl,
            "image-url": _vm.imageUrl,
            "highlight": _vm.highlight,
            "title": _vm.label,
            "aria-label": _vm.label
          },
          on: {
            "click": _vm.handleClick
          }
        }, 'ProfileBtn', Object.assign({}, attrs, _vm.$attrs, _vm.btnProps), false), [_vm._v("\n      " + _vm._s(_vm.labelFormatted) + "\n      "), _c('ChevronIcon', {
          attrs: {
            "slot": "icon-right"
          },
          slot: "icon-right"
        })], 1)];
      }
    }], null, false, 3904101575)
  }, [_vm._v(" "), _c('ProfileEmbedContainer', {
    attrs: {
      "is-open": _vm.isOpen,
      "options": _vm.embedOptions,
      "embed-type": _vm.embedType,
      "id": _vm.embedId
    }
  })], 1) : _c('ProfileBtn', _vm._b({
    staticClass: "v-profile-btn",
    attrs: {
      "url": _vm.linkUrl,
      "image-url": _vm.imageUrl,
      "highlight": _vm.highlight,
      "title": _vm.label,
      "aria-label": _vm.label
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'ProfileBtn', Object.assign({}, _vm.$attrs, _vm.btnProps), false), [_vm._v("\n  " + _vm._s(_vm.labelFormatted) + "\n")]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = "data-v-57d2a818";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var FeedBtn = __vue_component__;
export { FeedBtn as default };